
let __templates_registered = false;

export enum WebsiteType {
    HOST = "HOST",
    TEAM = "TEAM",
    MEMBER = "MEMBER",
    TOURNAMENT = "TOURNAMENT",
};

export const __template_registry__: { [key: string]: { [key: string]: { default: any; }; } } = {
    [WebsiteType.HOST]: {},
    [WebsiteType.TEAM]: {},
    [WebsiteType.MEMBER]: {},
    [WebsiteType.TOURNAMENT]: {},
};

function getWebsiteType(name: string) {
    if (name === "te" || name === "team") return WebsiteType.TEAM;
    if (name === "ho" || name === "host") return WebsiteType.HOST;
    if (name === "to" || name === "tournament") return WebsiteType.TOURNAMENT;
    return WebsiteType.MEMBER;
}

function __registerTemplate(type: WebsiteType, template: string, component: any) {
    __template_registry__[type][template] = component;
}

export function getTemplateComponent(path: string, template: string) {
    const type = getWebsiteType(path);
    let component = __template_registry__[type][template];
    if (!component) {
        require("@rivtn/noseur").Debugger.error("DASHBOARD.PROFILE.CREATE", "Cannot found the template", type, template, "falling back to default 'launchpad'");
        template = "launchpad";
        component = __template_registry__[type][template];
    }
    return component;
}

if (!__templates_registered) {
    __templates_registered = true;
    // MEMBER
    __registerTemplate(WebsiteType.MEMBER, "sleeky", require("./member/sleeky/definition"));
    __registerTemplate(WebsiteType.MEMBER, "launchpad", require("./member/launchpad/definition"));

    // TEAM
    __registerTemplate(WebsiteType.TEAM, "launchpad", require("./team/launchpad/definition"));

    // HOST
    __registerTemplate(WebsiteType.HOST, "launchpad", require("./host/launchpad/definition"));

    // TOURNAMENT
    __registerTemplate(WebsiteType.TOURNAMENT, "launchpad", require("./tournament/launchpad/definition"));
}
